import axios from "axios";
import Cookies from "js-cookie";
import { APILINK } from "../EndPoint";

const axiosInstance = axios.create({
    baseURL: APILINK,
    headers: {
        // "Accept-Language": "aaaaaa"
    }
});

export default axiosInstance;